"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementIsTruncated = useElementIsTruncated;
var _react = require("react");
function useElementIsTruncated() {
  var _ref = (0, _react.useState)(null),
    _ref2 = _slicedToArray(_ref, 2),
    ref = _ref2[0],
    setRef = _ref2[1];
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    isTruncated = _ref4[0],
    setIsTruncated = _ref4[1];
  var handleSize = (0, _react.useCallback)(function () {
    var scrollHeight = (ref === null || ref === void 0 ? void 0 : ref.scrollHeight) || 0;
    var clientHeight = (ref === null || ref === void 0 ? void 0 : ref.clientHeight) || 0;
    setIsTruncated(scrollHeight > clientHeight);
  }, [ref]);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleSize);
    return function () {
      return window.removeEventListener('resize', handleSize);
    };
  }, [handleSize]);
  (0, _react.useEffect)(function () {
    handleSize();
  }, [handleSize, ref === null || ref === void 0 ? void 0 : ref.clientHeight, ref === null || ref === void 0 ? void 0 : ref.scrollHeight]);
  return [setRef, isTruncated];
}